export const getUserErrorMessage = (state) => state.user.error;



